// Constantes globais da aplicação
import { faSprayCanSparkles, faShieldHalved, faDroplet, faWind, faCar, faStar, faAward, faUsers, faClock, faHeart } from '@fortawesome/free-solid-svg-icons';

// URLs e Links
export const WA = 'https://wa.me/5548992152728';
export const INSTA = 'https://www.instagram.com/goshine.ea';
export const TIKTOK = 'https://www.tiktok.com/@goshine.ea';
export const MAP_URL = 'https://maps.google.com/?q=R.+Valter+Mussi,+61+-+Santa+Monica,+Florianópolis+-+SC';
export const MAP_EMBED = 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3535.8559098752513!2d-48.52890692355649!3d-27.60307252490859!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x95273865e1c3c9a1%3A0x4d7ae2c8b3b3b3b3!2sR.%20Valter%20Mussi%2C%2061%20-%20Santa%20M%C3%B4nica%2C%20Florian%C3%B3polis%20-%20SC%2C%2088035-160!5e0!3m2!1spt-BR!2sbr!4v1701878400000!5m2!1spt-BR!2sbr';

// Assets
export const LOGO = '/GOSHINE/MARCA/02 - GOSHINE - HORIZONTAL - RGB.svg';
export const SYMBOL = '/GOSHINE/MARCA/01 - GOSHINE - SIMBOLO - RGB.svg';
export const GRAFISMO = '/GOSHINE/GRAFISMO/GOSHINE - GRAFISMO 03 - RGB.png';

// Dados
export const IMGS = [...Array(8)].map((_, i) => ({ 
  src: `/GOSHINE/LAVAGENS/CARROS (${i + 1}).png`, 
  alt: `Serviço GoShine ${i + 1}` 
}));

export const NAV_ITEMS = [
  { id: 'galeria', text: 'Galeria' }, 
  { id: 'servicos', text: 'Serviços' }, 
  { id: 'sobre', text: 'Sobre' }, 
  { id: 'depoimentos', text: 'Depoimentos' }, 
  { id: 'contato', text: 'Contato' }
];

export const STATS = [
  { number: '2000+', label: 'Carros' }, 
  { number: '4', label: 'Boxes' }, 
  { number: '100%', label: 'Satisfação' }, 
  { number: '5+', label: 'Anos' }
];

export const SERVICES = [
  { icon: faSprayCanSparkles, title: 'Vitrificação', desc: 'Proteção de alta durabilidade contra riscos, UV e contaminantes.', features: ['Brilho intenso', 'Proteção UV', 'Até 3 anos'] },
  { icon: faShieldHalved, title: 'Polimento Técnico', desc: 'Remove arranhões e imperfeições, restaurando o brilho original.', features: ['Remove arranhões', 'Elimina hologramas', 'Brilho showroom'] },
  { icon: faWind, title: 'Higienização Ozônio', desc: 'Elimina odores, fungos e bactérias do interior do veículo.', features: ['Elimina odores', 'Mata 99% bactérias', 'Ideal alérgicos'] },
  { icon: faDroplet, title: 'Lavagem Premium', desc: 'Pré-lavagem que protege a pintura contra micro arranhões.', features: ['Produtos Faggen', 'Técnica safe-wash', 'Detalhes'] },
  { icon: faCar, title: 'Limpeza Interna', desc: 'Higienização profunda de bancos, carpetes e painéis.', features: ['Bancos e carpetes', 'Painéis e portas', 'Sanitização'] },
  { icon: faStar, title: 'Detalhamento', desc: 'Cuidado especial em cada canto do veículo.', features: ['Pincéis especiais', 'Cada detalhe', 'Acabamento'] },
];

export const TESTIMONIALS = [
  { name: 'Carlos Mendes', text: 'Incrível! Meu carro voltou como se tivesse saído da concessionária.', car: 'BMW 320i' },
  { name: 'Amanda Silva', text: 'Atendimento excepcional. O resultado superou minhas expectativas.', car: 'Jeep Compass' },
  { name: 'Roberto Alves', text: 'A higienização com ozônio resolveu o problema de odor. Recomendo!', car: 'Honda Civic' },
];

export const DIFFERENTIALS = [
  { icon: faAward, title: 'Produtos Premium', desc: 'Produtos de alta qualidade como Faggen.' },
  { icon: faUsers, title: 'Equipe Especializada', desc: 'Profissionais apaixonados por carros.' },
  { icon: faClock, title: 'Pontualidade', desc: 'Agendamento fácil e entrega no prazo.' },
  { icon: faHeart, title: 'Paixão', desc: 'Dedicação e amor aos carros.' },
];

export const TECHNOLOGIES = [
  { 
    title: 'Higienização', 
    highlight: 'Ozônio', 
    label: 'Tecnologia Exclusiva', 
    desc: 'Gerador de ozônio que elimina odores, fungos e bactérias. Ideal para carros com crianças ou pets.', 
    items: ['Elimina odores', 'Combate bactérias', '~20 minutos'] 
  },
  { 
    title: 'Pré-Lavagem', 
    highlight: 'Safe-Wash', 
    label: 'Técnica Premium', 
    desc: 'Técnica que flota a sujeira antes do contato físico, evitando micro arranhões na pintura.', 
    items: ['Remove sujeira pesada', 'Pincéis especiais', 'Protege a pintura'] 
  },
];
